module.exports = __webpack_public_path__ + "assets/img/login-logo@2x.bfe9bf10.png";